module.exports = __webpack_public_path__ + "img/page_info_nodata2.fc3b7bf.svg";